import Vue from 'vue';
import axios from 'axios';
import cookie from 'vue-cookie';
import qs from 'qs'
import {  Dialog, Toast } from 'vant';
Vue.use(Dialog).use(Toast);

const service = axios.create({
  baseURL: process.env.BASE_IOT_API,
  timeout: 10000
});

// request拦截器
service.interceptors.request.use(
  config => {
    const token = cookie.get('_ibl') || ''
    if (token !== '') {
      config.headers.Authorization = token // 让每个请求携带token 请根据实际情况自行修改
    }
    if (config.method === 'post') {
      config.data = qs.stringify(config.data); // 传参序列化
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);
// code状态码0判断
service.interceptors.response.use(
  response => {
    // 判定token是否刷新
    if (response.headers.authorization) {
      cookie.set('_ibl', response.headers.authorization);
    }

    const res = response.data;
    if (res.code === 0) {
      return res
    } else if (res.code === 400401) {
      Dialog.alert({
        title: '请登录',
        className: 'myDialogStyle'
      }).then(() => {
        location.replace(`/m/login?redirect=${encodeURIComponent(location.href)}`)
      })
      return Promise.reject(res.message);
    } else {
      Toast.fail(res.data.message);
      return Promise.reject(res.message);
    }
  },
  error => {
    return Promise.reject(error);
  }
);

export default {
  post(url, data) {
    console.log(data)
    return service({
      url: url,
      method: 'post',
      data: data
    })
  },
  get(url, data) {
    return service({
      url: url,
      method: 'post',
      params: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/request.js